// Reloads the enclosing turbo-frame until ScoreToxicityJob resolves
// publication. The resolved frame no longer renders this component, which ends
// the polling. Scoping the reload to the frame keeps Alpine state elsewhere on
// the page (header search, menus) intact; a whole-page morph would strip the
// inline styles Alpine's x-show manages.
export default function entryReceiptProcessing(pollIntervalMs) {
  let poll = null;

  return {
    init() {
      const frame = this.$root.closest('turbo-frame');
      poll = setInterval(() => {
        if (frame.src) {
          frame.reload();
        } else {
          frame.src = window.location.href;
        }
      }, pollIntervalMs);
    },
    destroy() {
      clearInterval(poll);
    },
  };
}
